import React, { Component } from "react";
import AntdPagination, {PaginationProps} from 'antd/lib/pagination';
import 'antd/lib/pagination/style';

export default class Pagination extends Component<PaginationProps> {
    render() {
        return (
          <AntdPagination {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/pagination/index.tsx